'use strict';

angular.module('BusinessUnitsControllers')

.controller('BusinessUnitEditController', ['$scope', '$q', '$state', '$modal', 'topBar', 'adminBusinessUnitsService', 'authenticatedUser', 'businessUnit', 'businessUnits', '$translate',
                                    function ($scope, $q, $state, $modal, topBar, administrationService, authenticatedUser, businessUnit, businessUnits, $translate) {

    $scope.bu = businessUnit;
    $scope.ctrlCtxt = { needSavesChanges: false };

    /* Filter business unit list for parent search and selection */
    $scope.BusinessUnitsParentAvailableList = _.filter(businessUnits, function (buTemp) {
        return (buTemp.BusinessUnitID !== $scope.bu.BusinessUnitID &&
                $scope.bu.BusinessUnitID !== buTemp.ParentBusinessUnitID) ||
                !$scope.bu.BusinessUnitID;
    });

    /* Handle text area height depending on text entry */
    $scope.handleTextAreaHeight = function (e) {
        var element = e.target;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.height = element.scrollHeight + 'px';
    };

    /* Go to business unit - parent or child related */
    $scope.goToBusinessUnit = function (businessUnitID) {
        $state.go('adminBusinessUnits.businessUnitEdit', { BusinessUnitID: businessUnitID });
    }

    /* Remove business unit head */
    $scope.removeHead = function () {
        $scope.bu.Head = null;
        $scope.bu.HeadID = null;
        $scope.pageIsDirty();
    }

    /* Remove business unit's head assistant */
    $scope.removeAssistant = function () {
        $scope.bu.Assistant = null;
        $scope.pageIsDirty();
    }

    /* Update business unit by calling API */
    $scope.updateBusinessUnit = function () {
        $scope.bu.HeadID = $scope.bu.Head ? $scope.bu.Head.EmployeeID : null;
        $scope.bu.AssistantID = $scope.bu.Assistant ? $scope.bu.Assistant.EmployeeID : null;

        administrationService.updateBusinessUnit($scope.bu)
                             .then(function (updatedBU) {
                                 if (!_.isUndefined(updatedBU.GrowlMessages)) return;

                                 $scope.bu = updatedBU;
                             });
        $scope.pageIsNotDirty();
    }

    // Create a business unit by calling API
    $scope.createBusinessUnit = function () {
        $scope.bu.HeadID = $scope.bu.Head ? $scope.bu.Head.EmployeeID : null;
        $scope.bu.AssistantID = $scope.bu.Assistant ? $scope.bu.Assistant.EmployeeID : null;

        administrationService
            .createBusinessUnit($scope.bu)
            .then(function (businessUnit) {
                if (!_.isUndefined(businessUnit.GrowlMessages)) return;

                $state.go('adminBusinessUnits.businessUnitEdit', {
                    BusinessUnitID: businessUnit.BusinessUnitID
                }, {
                    reload: true
                });
        });
        $scope.pageIsNotDirty();
    }

    // Remove a business unit if it has no child by calling API
    $scope.deleteBusinessUnit = function () {
        administrationService.deleteBusinessUnit($scope.bu)
                             .then(function () {
                                 $state.go('adminBusinessUnits', {}, { reload: true });
                             });
    };

    var primaryMemberIdList = _.filter()

    /* Open modal to search and select employee to be Head or Assistant */
    $scope.selectEmployee = function (title) {
        if (title === 'assistant' && !$scope.bu.HeadID) return;

        var translationKey = title === 'head' ? 'iam.admin.businessUnits.modal.titleHead' : 'iam.admin.businessUnits.modal.titleAssistant';

        $translate(translationKey).then(function(translatedTitle) {
            var modalScope = $scope.$new(true);
            var employeePickerModal = $modal({
                scope: modalScope,
                template: require('./searchEmployee.tpl.html'),
                placement: 'center',
                title: translatedTitle,
                show: true
            });

            /* Select employee from searching result list */
            modalScope.selectEmployee = function (employeeSelected) {
                if (title === 'head') $scope.bu.Head = employeeSelected;
                if (title === 'assistant') $scope.bu.Assistant = employeeSelected;
                employeePickerModal.hide();
                $scope.pageIsDirty();
            }
        });
    };

    var forcedMemberInitIdList = _.pluck($scope.bu.ForcedMembers, 'EmployeeID');
    var setToPrimaryIdList = [];
    var primaryMemberInitIdList = _.pluck($scope.bu.PrimaryMembers, 'EmployeeID');
    var setToForcedIdList = [];

    // Move To Primary
    $scope.moveToPrimary = function (buMember) {
        $scope.bu.ForcedMembers = _.reject($scope.bu.ForcedMembers, { EmployeeID: buMember.EmployeeID });

        if (_.isUndefined($scope.bu.PrimaryMembers)) $scope.bu.PrimaryMembers = [];
        $scope.bu.PrimaryMembers.push(buMember);

        setToPrimaryIdList = _.difference(forcedMemberInitIdList,
                                          _.pluck($scope.bu.ForcedMembers, 'EmployeeID'));
        setToForcedIdList = _.difference(primaryMemberInitIdList,
                                  _.pluck($scope.bu.PrimaryMembers, 'EmployeeID'));
    };

    // Move To Forced
    $scope.moveToForced = function (buMember) {
        $scope.bu.PrimaryMembers = _.reject($scope.bu.PrimaryMembers, { EmployeeID: buMember.EmployeeID });

        if (_.isUndefined($scope.bu.ForcedMembers)) $scope.bu.ForcedMembers = [];
        $scope.bu.ForcedMembers.push(buMember);

        setToPrimaryIdList = _.difference(forcedMemberInitIdList,
                                     _.pluck($scope.bu.ForcedMembers, 'EmployeeID'));
        setToForcedIdList = _.difference(primaryMemberInitIdList,
                                  _.pluck($scope.bu.PrimaryMembers, 'EmployeeID'));
    };

    // Has Head Left?
    $scope.hasHeadLeft = function () {
        $scope.bu.Head
            && !_.isUndefined($scope.bu.Head.IsDepartureDateInTheFuture)
            && $scope.bu.Head.IsDepartureDateInTheFuture === false;
    };

    // Has Assistant Left?
    $scope.hasAssistantLeft = function () {
        $scope.bu.Assistant
            && !_.isUndefined($scope.bu.Assistant.IsDepartureDateInTheFuture)
            && $scope.bu.Assistant.IsDepartureDateInTheFuture === false;
    };

    // Show Confirm Bu Members List Change?
    $scope.showConfirmBUMembersListChange = function () {
        if (_.size(setToPrimaryIdList) > 0) return true;

        return _.size(setToForcedIdList) > 0;
    };

    // Confirm BU Member List Changes
    $scope.confirmBuMemberListChanges = function () {
        var promiseChain = $q.when();

        // Chain Set To Non Primary API Calls
        _.each(setToForcedIdList, function (employeeId) {
            promiseChain = promiseChain.then(function () {
                return administrationService.setNonPrimaryBusinessUnitForEmployee($scope.bu.BusinessUnitID,
                                                                                  employeeId);
            });
        });

        // Chain Set To Primary API Calls
        _.each(setToPrimaryIdList, function (employeeId) {
            promiseChain = promiseChain.then(function () {
                return administrationService.setPrimaryBusinessUnitForEmployee(employeeId);
            });
        });

        promiseChain.then(function () { $state.reload(); })
    };

    // Page Is Dirty
    $scope.pageIsDirty = function () {
        $scope.ctrlCtxt.needSavesChanges = true;
    };

    // Page Is Not Dirty
    $scope.pageIsNotDirty = function () {
        $scope.ctrlCtxt.needSavesChanges = false;
    };

    // Discard Changes
    $scope.discardChanges = function () {
        $state.reload();
    };

}]);
